export const useTotalResponsesCardStyles = () => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2,
        height: '100%'
    },
    totalNumber: {
        color: (theme) => theme.palette.primary.light,
        fontWeight: '500'
    },
    progressContainer: {
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column'
    }
});
